<template>
    <div id="printIp">
        <el-row>
            <el-col :span="2" class="labelText">ipAdd:</el-col>
            <el-col :span="22">{{ipAddr}}</el-col>
        </el-row>
        <el-row>
            <el-col :span="2" class="labelText">lastTime:</el-col>
            <el-col :span="22">{{lastTime}}</el-col>
        </el-row>
    </div>
</template>
<script>
export default {
    data(){
        return{
            ipAddr:'114.218.241.171',
            lastTime:'2019-07-02 12:27:20'
        }
    },
    mounted(){
        this.$http.get('/api/getIp').then(response=>{
            let res = response.data;
            if(res.status === 1){
                return
            }
            this.ipAddr = res.ipAddr
            this.lastTime = res.lastTime
        })
    }
}
</script>
<style>
#printIp{
    margin: 30px;
}
#printIp .el-row{
    margin-top: 20px;
}
.labelText{
    text-align: right;
    padding-right: 10px;
}
</style>


